import * as yup from 'yup'

import allowedValues from './allowed.values.js'
import { companySchema } from './general.schema.js'
import { createCompanySchemas } from './new.company.schema.js'

import { pageNum, pageSize, requiredString, requiredNumber, string } from '../yup/schemas.js'

import { VALIDATION } from '../constants.js'

const patchCompanyByMainRecruiterSchema = companySchema.omit(['id']).allFieldsOptional()
const patchCompanyByRecruiterSchema = patchCompanyByMainRecruiterSchema.omit(['dot'])

const getCompanyListQueryParamsSchema = yup.object({
  pageNum,
  pageSize,
  companyNameSearch: string,
  companyName: companySchema.get('name').optional()
}).objectRequired()

const uploadAvatarSchema = yup.object({
  fields: yup.object({}).objectRequired(),
  files: yup.object({
    avatar: yup.object({
      type: requiredString.matches(VALIDATION.REGEXP.IMAGE_MIME, VALIDATION.MESSAGES.IMAGE_MIME),
      size: requiredNumber.max(VALIDATION.AVATAR_MAX_SIZE),
      path: requiredString,
      name: requiredString
    }).required()
  }).objectRequired()
}).objectRequired()

const patchCompanyByRecruiterSchemas = { front: patchCompanyByRecruiterSchema, back: patchCompanyByRecruiterSchema }
const patchCompanyByMainRecruiterSchemas = { front: patchCompanyByMainRecruiterSchema, back: patchCompanyByMainRecruiterSchema }

const getByDotParamsSchemas = {
  back: companySchema.pick(['dot'])
}

const getCompanyListQueryParamsSchemas = { front: getCompanyListQueryParamsSchema, back: getCompanyListQueryParamsSchema }

const getCompanyParamsSchemas = {
  back: companySchema.pick(['id'])
}

const uploadAvatarSchemas = {
  front: yup.object({
    avatar: uploadAvatarSchema.get('files.avatar.path')
  }).objectRequired(),
  back: uploadAvatarSchema
}
const getRecruiterListParamsSchemas = {
  back: companySchema.pick(['id'])
}

const getRecruiterListQueryParamsSchema = yup.object({
  pageNum,
  pageSize
}).objectRequired()

const companySettingsApplicationUseSchemas = companySchema
  .pick(['useOurWebsiteApplicationForm', 'applicationLink'])

const companySettingsNotificationTypeSchema = companySchema
  .pick(['notificationAboutNewBoard'])

const getRecruiterListQueryParamsSchemas = { front: getRecruiterListQueryParamsSchema, back: getRecruiterListQueryParamsSchema }

export default {
  createCompany: createCompanySchemas,
  getByDotParams: getByDotParamsSchemas,
  getCompanyParams: getCompanyParamsSchemas,
  patchCompanyByRecruiter: patchCompanyByRecruiterSchemas,
  patchCompanyByMainRecruiter: patchCompanyByMainRecruiterSchemas,
  getCompanyListQueryParams: getCompanyListQueryParamsSchemas,
  getRecruiterListQueryParams: getRecruiterListQueryParamsSchemas,
  getRecruiterListParams: getRecruiterListParamsSchemas,
  uploadAvatar: uploadAvatarSchemas,
  companySettingsApplicationUse: companySettingsApplicationUseSchemas,
  companySettingsNotificationType: companySettingsNotificationTypeSchema,
  allowedValues
}
